import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20with%20flowing%20ink%20brush%20strokes%2C%20warm%20coral%20red%20and%20soft%20cream%20color%20palette%2C%20oriental%20aesthetic%20with%20modern%20minimalist%20composition%2C%20subtle%20paper%20texture%2C%20elegant%20and%20dynamic%20visual%20energy%2C%20no%20text%20or%20characters%2C%20soft%20dreamy%20atmosphere&width=1600&height=900&seq=yaya-hero-bg&orientation=landscape"
        alt="丫丫漫画背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading text-white mb-6 leading-tight">
            丫丫漫画
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-8 leading-relaxed max-w-2xl mx-auto">
            下拉式翻页在线阅读，免费畅享全集漫画<br />
            韩漫、日漫、国漫一应俱全，流畅舒适的阅读体验随时追更
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-white font-semibold rounded-full text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              立即阅读
            </Link>
            <Link
              to="/category/guoman"
              className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-full text-sm border border-white/20 hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              国漫专区
            </Link>
          </div>
          <div className="flex items-center justify-center gap-8 mt-12">
            <div className="text-center">
              <p className="text-3xl font-bold text-white">9+</p>
              <p className="text-xs text-white/60 mt-1">漫画分类</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-3xl font-bold text-white">5000+</p>
              <p className="text-xs text-white/60 mt-1">海量漫画</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-3xl font-bold text-white">1000万+</p>
              <p className="text-xs text-white/60 mt-1">忠实读者</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}